export default __webpack_public_path__ + "static/media/bdswissSCReal05_downloadMT4.99fc273e.png";